module.exports = __webpack_public_path__ + "static/media/telepharmacy.7c17091c.jpg";